import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

/**Componente per il modale di sola visualizzazione dati */
@Component({
  selector: 'app-display-only-dialog',
  templateUrl: './display-only-dialog.component.html',
  styleUrls: ['./display-only-dialog.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DisplayOnlyDialogComponent {

  /**
   * Costruttore per il componente DisplayOnlyDialogComponent
   * @param dialogRef {MatDialogRef<DisplayOnlyDialogComponent>}
   * @param data {object}
   */
  constructor(
    public dialogRef: MatDialogRef<DisplayOnlyDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      /**Titolo del dialog */
      title: string,
      /**Contenuto del dialog in HTML */
      content: string
    }
  ) { }

}
